import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import EventEmitter from '../../../../../utils/events'
// import Datetime from 'react-datetime'
// import moment from 'moment'
import { hasSubscriptionPermission, hasAccess } from '../../../../../utils/auth'
import { translation } from '../../../../../utils/helpers'
import { renderFullDate } from '../../../../../utils/time'
// Styles
// import { FILE_STORAGE_API } from '../../../../../constants'
import { getPickupTimes } from '../../../../../actions/orders'
// Elements
import SparePartsOverlay from '../../../../../shared/overlays/spareParts'
import Panel from '../../../../../shared/elements/panel'
import Button from '../../../../../shared/elements/button'
// import DateTime from '../../../../../shared/elements/datetime'
// import DropDown from '../../../../../shared/elements/dropDown'
import Divider from '../../../../../shared/elements/divider'

// Actions
import { openOverlay } from '../../../../../actions/common'

import SparepartList from './List'

// Component updaters
import { UpdateSparePartPremiumList } from './PremiumList'

class SpareParts extends Component {

  constructor (props) {
    super(props)
    this.state = {
      order: {}
    }
  }
  onInputChange (e) {
    this.props.onChange(e)
  }
  componentDidMount () {
  }
  componentWillReceiveProps (nextProps) {
    this.setState({
      order: nextProps.order
    })
  }

  getTimeString (timeString, date) {
    let toReturn = timeString
    if (date !== '') {
      // Hours + pad zero
      let hours = '' + date.getHours()
      hours = '00'.substring(0, 2 - hours.length) + hours
      // Minutes + pad zero
      let minutes = '' + date.getMinutes()
      minutes = '00'.substring(0, 2 - minutes.length) + minutes
      // Set time
      toReturn = hours + ':' + minutes
    }
    return toReturn
  }
  /* renderBodyShopSparePartDate () {
    // let pickupDate = this.state.order.BodyShopSparePartDate
    let pickupDate = this.state.order.SparePartDateDefault

    if (this.state.order.BodyShopSparePartDate !== null && this.state.order.BodyShopSparePartDate !== '1990-01-01T00:00:00') {
      pickupDate = this.state.order.BodyShopSparePartDate
    }

    let times = this.state.order.SparePartAvailableTimes
    let closeOnSelect = true
    let timeFormat = false
    let inputProps = {
      name: 'BodyShopSparePartDate',
      readOnly: true,
      disabled: !hasSubscriptionPermission(this.props.auth, 0, 2) || hasAccess([6], this.props.auth.user.UserType)
    }

    // Time string
    let timeString = ''
    if (times != null) timeString = times[0]
    // Date
    let date = ''
    if (typeof pickupDate !== 'undefined' && pickupDate !== null && pickupDate !== '') {
      date = window.CustomDate(pickupDate)
    }

    // Time string
    timeString = this.getTimeString(timeString, date)

    // Actions
    const onChange = (dateTime) => {
      this.setState({
        order: {
          ...this.state.order,
          BodyShopSparePartDate: dateTime,
          BodyShopSparePartDateTimes: []
        }
      }, () => {
        let newDate = moment(dateTime).format('YYYY-MM-DD')
        // let newTime = moment(dateTime).format('HH:mm')

        this.props.getPickupTimes(newDate, '08:00', this.state.order.CustomerId).then((res) => {
          let AvailableTimes = [''].concat(res.data.AvailableTimes)
          this.setState({
            order: {
              ...this.state.order,
              BodyShopSparePartDate: (res.data.IsSelectedDayValid) ? newDate + ' 08:00' : res.data.NextValidPickupDate,
              BodyShopSparePartDateTimes: AvailableTimes
            }
          }, () => {
            this.props.saveWorkcard(undefined, 'BodyShopSparePartDateTimes', undefined, this.state.order)
          })
        }, (err) => {
          // Toastr
          this.props.onUpdateOrder()
          window.toastr.error(translation(err.response.data.DictionaryKey), translation('216'))
        })
      })
    }
    const onChangeTime = (e) => {
      let splitted = e.target.value.split(':')
      let dateVal = (pickupDate !== null) ? window.CustomDate(pickupDate) : window.CustomDate()
      let momentDate = moment(dateVal)
      momentDate.set({ hour: splitted[0], minute: splitted[1], second: 0, millisecond: 0 })
      this.props.saveSingleValue('BodyShopSparePartDate', momentDate.format('YYYY-MM-DDTHH:mm'), () => {
        this.props.saveWorkcard(undefined, 'BodyShopSparePartDateTimes', undefined)
      })
    }
    // Return
    return (
      <div className='spacing'>
        <DateTime inputProps={inputProps} closeOnSelect={closeOnSelect} dateFormat='DD-MM-YYYY' timeFormat={timeFormat} value={date} onChange={onChange} />
        <DropDown
          name='BodyShopSparePartDate_time'
          value={timeString}
          onChange={onChangeTime}
          ref='BodyShopSparePartDate'
          // key={timeKey} // Breaks the dropdown for some reason
          disabled={hasAccess([6], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 0, 2)}
        >
          {times.map((val, index) => {
            return (<option key={index} value={val}>{val}</option>)
          })}
        </DropDown>
      </div>
    )
  } */

  render () {
    if (typeof this.state.order.Id === 'undefined') return null
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null

    const renderDownloadLink = (item) => {
      // Find reports
      const files = this.props.order.Report ? this.props.order.Report.Attachments : []
      if (!(files.length > 0)) {
        return null
      }

      // Look after sparepart reports
      const sparePartFile = files.find(f => f.SectionType === 4)
      if (sparePartFile !== undefined) {
        // TODO: Implement backend security check via token/session?
        const downloadURL = sparePartFile.FileUrl

        return (
          <div>
            <div className='inside'>{translation('14837')}
              <a href={downloadURL} title={sparePartFile.FileName} target='_blank'><img src='/images/svgs/download.svg' alt='' className='downloadIcon' /></a>
              <span className='simpleFloatRight'>{renderFullDate(this.props.order.Report.CreatedDate)}</span>
              <div className='clearFix' />
            </div>
          </div>
        )
      }

      // We didn't find any?
      return null
    }
    const renderInputContent = () => {
      if (!this.state.order.HasSpareParts) return null
      return (
        <div className='information'>
          {(this.props.auth.user.UserType !== 4) && <Divider size={2} />}
        </div>
      )
    }
    const renderContent = () => {
      const onOpenSparePartsOverlay = (e) => {
        e.preventDefault()
        this.props.openOverlay('SparePartsOverlay')
      }
      let hasPermissionToSparePartsOverlay = hasSubscriptionPermission(this.props.auth, 30, 31)
      const disableSparePartsOverlayButton = this.props.disableMobileAccess || this.state.order.IsReferredOut || !hasPermissionToSparePartsOverlay
      const isCustomer = hasAccess([4], this.props.auth.user.UserType)

      return (
        <div>
          {!isCustomer && (
            <div>
              <Button style='link' onClick={onOpenSparePartsOverlay} disabled={disableSparePartsOverlayButton}>{translation(16433)}</Button>
              <Divider size={2} />
            </div>
          )}
          <div className='information'>
            {this.props.auth.user.UserType !== 4 && this.props.renderInput(translation('637'), 'HasSpareParts', undefined, 'checkbox')}
            {renderInputContent()}
          </div>
          {renderDownloadLink()}
          {<SparepartList
            order={this.props.order}
            showRpFiles
          />}
        </div>
      )
    }

    const onClose = () => {
      this.props.onUpdateOrder()
      EventEmitter.emit('UPDATE_BOOKINGTIMES')
      UpdateSparePartPremiumList(this.state.order.Id)
    }
    return (
      <Panel title={translation('637')} dataCol='spareparts'>
        {renderContent()}
        <SparePartsOverlay order={this.state.order} onClose={onClose} />
      </Panel>
    )
  }
}

SpareParts.defaultProps = {
}

SpareParts.propTypes = {
  saveSingleValue: PropTypes.func.isRequired,
  saveWorkcard: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  renderInput: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
}

SpareParts.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  getPickupTimes,
  openOverlay
})(SpareParts)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/SpareParts/index.js